<template>
  <b-modal
    id="modalCreateEditCategoriaConta"
    size="xl"
    :title="textModal"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
    @hidden="$emit('closeModal', false)"
  >
    <form @submit.prevent="save">
      <div class="form-row">
        <div class="form-group col-sm-6">
          <label>Descricao: <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': $v.categoriaConta.descricao.$error }"
            placeholder="Descrição da categoria de conta"
            v-model="$v.categoriaConta.descricao.$model"
          />
          <span
            v-if="!$v.categoriaConta.descricao.required"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
          <span
            v-if="!$v.categoriaConta.descricao.minLength"
            class="invalid-feedback"
          >
            A descrição deve possuir pelo menos 3 caracteres
          </span>
        </div>
        <div class="form-group col-sm-4">
          <label>Tipo:</label>
          <select
            class="form-control"
            :class="{ 'is-invalid': $v.categoriaConta.tipo.$error }"
            v-model="$v.categoriaConta.tipo.$model"
          >
            <option value="">Selecione um tipo</option>
            <option value="1">Receita</option>
            <option value="0">Despesa</option>
          </select>
          <span
            v-if="!$v.categoriaConta.tipo.required"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
        </div>
      </div>
      <div v-if="categoriaContaId" class="form-row">
        <div class="form-group col-sm-6">
          <p>Status: <span class="text-danger">*</span></p>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="statusInativo"
              value="0"
              v-model="categoriaConta.status"
            />
            <label class="form-check-label" for="statusInativo">
              Inativo
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="statusAtivo"
              value="1"
              v-model="categoriaConta.status"
            />
            <label class="form-check-label" for="statusAtivo"> Ativo </label>
          </div>
        </div>
      </div>
      <hr />
      <div class="modal-footer-custom">
        <button
          type="button"
          class="btn btn-secondary"
          title="Cancelar"
          @click="$emit('closeModal', false)"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :title="textModal"
          :disabled="$v.$invalid || disableButton"
        >
          <i
            v-if="disableButton"
            class="spinner-grow spinner-grow-custom text-wither"
          />
          <span v-else>{{ textModal }}</span>
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'CreateEditCategoriaContaModal',
  props: {
    categoriaContaId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      categoriaConta: {
        descricao: '',
        tipo: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.categoriaContaId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getCategoriaConta() {
      try {
        this.categoriaConta = await this.$store.dispatch(
          'getCategoriaConta',
          this.categoriaContaId,
        )
        this.$bvModal.show('modalCreateEditCategoriaConta')
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.$v.$invalid) {
        this.disableButton = true
        try {
          let response = null
          if (this.categoriaContaId) {
            response = await this.$store.dispatch('updateCategoriaConta', {
              categoriaContaId: this.categoriaContaId,
              categoriaConta: this.categoriaConta,
            })
          } else {
            response = await this.$store.dispatch(
              'saveCategoriaConta',
              this.categoriaConta,
            )
          }
          this.disableButton = false
          this.$root.$bvToast.toast(response.message, {
            title: 'Sucesso!',
            variant: 'success',
            solid: true,
          })
          this.$emit('closeModal', true)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$bvToast.toast(error.message, {
              title: 'Atenção!',
              variant: 'warning',
              solid: true,
            })
          } else {
            this.$root.$bvToast.toast(
              'Não foi possível se conectar ao servidor.',
              {
                title: 'Erro!',
                variant: 'danger',
                solid: true,
              },
            )
          }
        }
      }
    },
  },

  validations: {
    categoriaConta: {
      descricao: {
        required,
        minLength: minLength(3),
      },
      tipo: {
        required,
      },
    },
  },

  mounted() {
    if (this.categoriaContaId) {
      this.getCategoriaConta()
    } else {
      this.$bvModal.show('modalCreateEditCategoriaConta')
    }
  },
}
</script>
